"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryKeyMutator = void 0;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const queryKeyMutator = ({ operationName, params }, _queryOptions) => {
    return [operationName, ...(params ? Object.values(params) : [])];
};
exports.queryKeyMutator = queryKeyMutator;
//# sourceMappingURL=queryKeyMutator.js.map